export const mayUppercase = "LCqLXc";
export default {mayUppercase};